import styled, { css } from 'styled-components';

import { size } from '../../layout/helpers';
import { ButtonReset } from '../../layout/reset';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

interface ActionProps {
  $horizontal?: boolean;
}
export const Actions = styled.div<ActionProps>`
  display: ${({ $horizontal }) => ($horizontal ? 'flex' : 'block')};
`;

interface BtnProps {
  $horizontal?: boolean;
}
export const Btn = styled(ButtonReset)<BtnProps>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${size(2.5)};
  height: ${size(2)};
  color: var(--c-accent-fg);
  border-radius: 1px;
  transform-origin: 50% 50%;
  transition: transform 200ms ease;

  // Hover overlay
  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background: var(--c-accent-bg);
    border-radius: inherit;
    opacity: 0;
    z-index: -1;
  }

  // Hover ghost
  &::after {
    content: '';
    position: absolute;
    inset: ${size(-0.25)} ${size(-1.5)};
  }

  &:first-child {
    &::after {
      top: ${size(-1)};
    }
  }

  &:last-child {
    &::after {
      bottom: ${size(-1)};
    }
  }

  &:not([disabled]):hover {
    &::before {
      opacity: 1;
    }
  }

  &:active {
    transform: scale(0.92);
  }

  &[disabled] {
    opacity: 0.37;
    cursor: not-allowed;
  }

  ${({ $horizontal }) =>
    $horizontal &&
    css`
      &:not(:last-child) {
        margin-right: ${size(0.5)};
      }
    `}

  ${({ $horizontal }) =>
    !$horizontal &&
    css`
    margin-top: ${size(0.5)};
  `}
`;

export const Order = styled.div`
  flex-shrink: 0;
  margin-left: ${size(2)};
  color: var(--c-text-muted);
  font-size: ${(props) => props.theme.font.size.small};
`;
